// extracted by mini-css-extract-plugin
export default {"profileDiv":"Profile_profileDiv__6vl1G"};